import palette from '../palette';

export default {
  // 3 columns: equal side cells keep the title centred with or without the
  // back button or hold timer (each is optional and sits in its own cell).
  appbarToolbar: {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1fr) auto minmax(0, 1fr)',
    alignItems: 'center',
    '@media (max-width: 359.95px)': { paddingLeft: 8, paddingRight: 8 },
  },
  appbarSideStart: { justifySelf: 'start' },
  appbarSideEnd: { justifySelf: 'end' },
  appbarBackButton: {
    '@media (max-width: 359.95px)': { marginLeft: -4 },
  },
  // Fixed-width clock ("10:00" worth) so neither pill nor title moves per tick.
  holdTimer: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    padding: '2px 8px',
    borderRadius: 999,
    backgroundColor: 'rgba(255, 255, 255, 0.12)',
    // Inset outline: gives the pill a visible edge without changing its box size.
    boxShadow: 'inset 0 0 0 1px rgba(255, 255, 255, 0.7)',
    color: '#fff',
    lineHeight: 1.5,
    '@media (max-width: 359.95px)': { padding: '2px 4px' },
  },
  // Under 2 min: white pill, dark amber text (same colour the warning Alert uses).
  holdTimerWarning: {
    backgroundColor: '#fff',
    boxShadow: 'none',
    color: 'rgb(102, 60, 0)',
  },
  holdTimerIcon: {
    fontSize: '1rem',
    '@media (max-width: 359.95px)': { display: 'none' },
  },
  holdTimerClock: {
    display: 'inline-block',
    width: '4.5ch',
    textAlign: 'center',
    fontVariantNumeric: 'tabular-nums',
  },
  appbarTitleContainer: {
    flexGrow: 1,
    padding: '10px 0',
    '& h1': {
      color: 'inherit',
    },
    '& a': {
      textDecoration: 'none',
      color: 'inherit',
    },
    color: palette.primary,
  },
  // Stepped so the title keeps >=8px clear of the hold pill (and back arrow):
  // 24px needs 404px+, 20px needs 372px+ (the pill's icon returns at 360px).
  appbarTitle: {
    fontSize: '1.5em',
    '@media (max-width: 403.98px)': { fontSize: '1.25em' },
    '@media (max-width: 371.98px)': { fontSize: '1.125em' },
  },
  appbarSubTitle: {
    fontSize: '1.2em',
  },
};
